import { useEffect, useState } from "react";
import {
    getWeekDays,
    getBranchUsersWithoutTime
} from "../../api/workingHoursApi";
import WorkingHoursModal from "../../components/WorkingHoursModal/WorkingHoursModal";
import "./WorkingHours.css";

export default function WorkingHours() {
    const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [days, setDays] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const branch = JSON.parse(localStorage.getItem("branch"));

    useEffect(() => {
        loadUsers();
        loadDays();
    }, []);

    const loadUsers = async () => {
        try {
            const data = await getBranchUsersWithoutTime(branch.id);

            console.log("API users:", data); // 👈 SHU YERGA

            setUsers(data);
        } catch (err) {
            console.error("Failed to load users:", err);
        }
    };


    const loadDays = async () => {
        const data = await getWeekDays();
        setDays(data);
    };

    const toggleUser = (id) => {
        setSelectedUsers((prev) =>
            prev.includes(id)
                ? prev.filter((u) => u !== id)
                : [...prev, id]
        );
    };

    const selectAll = () => {
        if (selectedUsers.length === users.length) {
            setSelectedUsers([]);
        } else {
            setSelectedUsers(users.map((u) => u.id));
        }
    };

    return (
        <div className="working-hours-page">
            <h1>Working Hours</h1>

            <div className="working-card">

                <div className="users-header">
                    <label>
                        <input
                            type="checkbox"
                            checked={
                                selectedUsers.length === users.length &&
                                users.length > 0
                            }
                            onChange={selectAll}
                        />
                        Select All
                    </label>

                    <span>
                        {selectedUsers.length} selected
                    </span>
                </div>

                <div className="users-grid">
                    {users.map((user) => (
                        <label key={user.id} className="user-row">
                            <input
                                type="checkbox"
                                checked={selectedUsers.includes(user.id)}
                                onChange={() => toggleUser(user.id)}
                            />
                            <span>{user.name}</span>
                        </label>
                    ))}
                </div>

                <button
                    className="save-btn-large"
                    disabled={selectedUsers.length === 0}
                    onClick={() => setIsModalOpen(true)}
                >
                    Select Working Hours
                </button>

            </div>

            {isModalOpen && (
                <WorkingHoursModal
                    selectedUsers={selectedUsers}
                    days={days}
                    onClose={() => {
                        setIsModalOpen(false);
                        loadUsers(); // refresh after save
                    }}
                />
            )}
        </div>
    );
}
